<template>
  <div class="content--sinoreg">
    <StepsForWizard class="mb-5"
                    :ativo="passoAtivo"
                    :passos="passos"
                    tamanho="sm" />

    <div class="pt-2">
      <CartorioServentia v-show="passoAtivo == 0"
                         :prop-wizard="true"
                         @changed="getDadosCartorio" />

      <ServentiaAcessGroups v-show="passoAtivo == 1"
                            :prop-wizard="true"
                            @changed="getGruposAcesso" />

      <UsuariosServentia v-show="passoAtivo == 2"
                         :prop-wizard="true"
                         :prop-passo="passoAtivo"
                         @changed="getUsuarios" />

      <FormConfigLivros v-show="passoAtivo == 3"
                        :prop-wizard="true"
                        @changed="getConfigLivros" />

      <FormSequenLivros v-show="passoAtivo == 4"
                        :prop-wizard="true"
                        @changed="getSequenLivros" />

      <hr class="hr-wizard">

      <div class="row no-gutters justify-content-end align-items-center">
        <button v-show="passoAtivo > 0"
                class="btn btn-sm btn-light"
                @click="previousStep()">
          Voltar
        </button>
        <button class="btn btn-sm btn-primary ml-2"
                @click="nextStep()">
          {{ passoAtivo !== 4 ? 'Continuar' : 'Finalizar' }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import StepsForWizard from '@/components/SofiaRei/StepsForWizard'
  import CartorioServentia from '@/components/SofiaRei/Serventia/CartorioServentia'
  import ServentiaAcessGroups from '@/components/SofiaRei/Serventia/ServentiaAcessGroups.vue'
  import UsuariosServentia from '@/components/SofiaRei/Serventia/UsuariosServentia.vue'
  import FormConfigLivros from '@/components/SofiaRei/Serventia/FormConfigLivros'
  import FormSequenLivros from '@/components/SofiaRei/Serventia/FormSequenLivros'
  import Swal from 'sweetalert2'
  import moment from 'moment'

  /* services */
  import LivroService from '@/services/LivroService'
  import CartorioService from "@/services/CartorioService"

  export default {
    name: 'Wizard',
    components: {
      CartorioServentia,
      StepsForWizard,
      ServentiaAcessGroups,
      UsuariosServentia,
      FormConfigLivros,
      FormSequenLivros
    },
    provide () {
      return {
        $validator: this.$validator,
      }
    },
    data () {
      return {
        passos: [
          { texto: 'Cartório' },
          { texto: 'Grupo de acesso' },
          { texto: 'Usuários' },
          { texto: 'Configurações dos livros' },
          { texto: 'Sequência de livros' }
        ],
        livros: [
          'Livro A',
          'Livro B',
          'Livro B - Auxiliar',
          'Livro C',
          'Livro C - Auxiliar',
          'Livro D',
        ],
        passoAtivo: 0,
        dados: {}
      }
    },
    methods: {
      getDadosCartorio (dados) {
        this.dados = {
          ...this.dados,
          cartorio: dados
        }

        // Atualizamos o objeto inteiro para o vue reconhecer as atualizações
        this.dados = { ...this.dados }
      },
      getGruposAcesso (grupos) {
        this.dados = {
          ...this.dados,
          grupos: grupos
        }

        // Atualizamos o objeto inteiro para o vue reconhecer as atualizações
        this.dados = { ...this.dados }
      },
      getUsuarios (usuarios) {
        this.dados = {
          ...this.dados,
          usuarios: usuarios
        }

        // Atualizamos o objeto inteiro para o vue reconhecer as atualizações
        this.dados = { ...this.dados }
      },
      getConfigLivros (configs) {
        this.dados = {
          ...this.dados,
          configs: configs
        }

        // Atualizamos o objeto inteiro para o vue reconhecer as atualizações
        this.dados = { ...this.dados }
      },
      getSequenLivros (sequen) {
        this.dados = {
          ...this.dados,
          sequen: sequen
        }

        // Atualizamos o objeto inteiro para o vue reconhecer as atualizações
        this.dados = { ...this.dados }
      },
      previousStep () {
        if (this.passoAtivo > 0) {
          window.scrollTo({top: 0, behavior: "smooth"})
          this.passoAtivo--
        }
      },
      async nextStep () {
        this.$validator.validate().then(async resp => {
          if (resp) {
            switch (this.passoAtivo) {
            case 0:
              return this.verifyCartorio()
            case 1:
              return this.verifyUsers()
            case 2:
              return this.verifyGroups()
            case 3:
              return this.verifyConfig()
            case 4:
              return this.verifySequen()
            default:
              return null
            }
          } else {
            let invalids = document.querySelectorAll('.is-invalid')

            if (invalids && invalids.length) {
              invalids[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: "nearest" })
            }
          }
        })
      },
      async verifyCartorio () {
        try {
          loader({ text: 'Atualizando dados do cartório', active: true })

          if (this.dados.cartorio.cnpj) {
            this.dados.cartorio.cnpj = this.dados.cartorio.cnpj.replace(/\D/g, "")
          }

          this.dados.cartorio.inicio_cartorio = moment(this.dados.cartorio.inicio_cartorio).format('YYYY-MM-DD')

          if (this.dados.cartorio.aliquota_issqn && this.dados.cartorio.aliquota_issqn.search('%') >= 0) {
            this.dados.cartorio.aliquota_issqn = this.dados.cartorio.aliquota_issqn.replace('%', '')
          }

          if (this.dados.cartorio.cei) {
            this.dados.cartorio.cei = parseInt(this.dados.cartorio.cei, 10)
          }

          await CartorioService.updateCartorioRei(this.dados.cartorio)


          window.scrollTo({top: 0, behavior: "smooth"})
          return this.passoAtivo++
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({ text: '', active: false })
        }
      },
      verifyUsers () {
        if (!this.dados.usuarios || !this.dados.usuarios.length) {
          return this.displayQuestion('Cadastre ao menos um usuário.', null, null)
        } else {
          window.scrollTo({top: 0, behavior: "smooth"})
          this.passoAtivo++
        }
      },
      verifyGroups () {
        if (!this.dados.grupos || !this.dados.grupos.length) {
          return this.displayQuestion('Cadastre ao menos um grupo.', null, null)
        } else {
          window.scrollTo({top: 0, behavior: "smooth"})
          this.passoAtivo++
        }
      },
      async verifyConfig () {
        if (!this.dados.configs) {
          return displayMessage('error', 'Erro!', 'Cadastro de configuração dos livros inválida')
        }

        let configsNotFound = this.dados.configs.filter(config =>{
          let {pag_final, pag_inicial, qtd_paginas, qtd_termo} = config

          pag_final = parseInt(pag_final, 10)
          pag_inicial = parseInt(pag_inicial, 10)
          qtd_paginas = parseInt(qtd_paginas, 10)
          qtd_termo = parseInt(qtd_termo, 10)

          if ((!pag_final > 0) || (!pag_inicial > 0) || (!qtd_paginas > 0) || (!qtd_termo > 0)) return true
        }).map(config => config.titulo)

        if (configsNotFound.length) {
          return this.displayErrors(null, null, configsNotFound)
        } else {
          try {
            const cartorio_id = this.$store.state.auth.cartorio_id

            loader({ text: 'Atualizando configuração dos livros', active: true })
            for (let val of this.dados.configs) {
              let objEnvio = { ...val, cartorio_id: cartorio_id }
              delete objEnvio.titulo

              await LivroService.sendConfigLivro(objEnvio)
            }

            window.scrollTo({top: 0, behavior: "smooth"})
            this.passoAtivo++
          } catch (error) {
            const message = getErrors(error)

            displayMessage('error', 'Erro!', message.message)
          } finally {
            loader({ text: '', active: false })
          }
        }
      },
      async verifySequen () {
        if (!this.dados.sequen) {
          return displayMessage('error', 'Erro!', 'Cadastro de sequência dos livros inválida')
        }

        let seqNotFound = this.dados.sequen.filter(seq =>{

          let {lado_atual, folha_atual, num_livro_atual, termo_atual} = seq

          folha_atual = parseInt(folha_atual, 10)
          num_livro_atual = parseInt(num_livro_atual, 10)
          termo_atual = parseInt(termo_atual, 10)

          if (!lado_atual || (!folha_atual > 0) || (!num_livro_atual > 0) || (!termo_atual > 0)) return true
        }).map(config => config.titulo)

        if (seqNotFound.length == 6) return this.displayErrors('Cadastre ao menos uma sequência.','', null)

        if (seqNotFound.length) {
          return this.displayQuestion(null, null, seqNotFound)
        } else {
          try {
            const cartorio_id = this.$store.state.auth.cartorio_id

            loader({ text: 'Atualizando configuração dos livros', active: true })
            for (let val of this.dados.sequen) {
              if (val.lado_atual !== '') {
                let objEnvio = { ...val, cartorio_id: cartorio_id }
                delete objEnvio.titulo

                await LivroService.sequenLivro(objEnvio)
              }
            }

            this.finish()
          } catch (error) {
            const message = getErrors(error)

            displayMessage('error', 'Erro!', message.message)
          } finally {
            loader({ text: '', active: false })
          }
        }
      },
      displayErrors (title, text, itens) {
        let html = null

        if (itens && itens.length) {
          html = `<p>Faltam as configurações para os seguintes livros:</p>
          <ul>${itens.map(res => `<li><b>${res}</b></li>`)}</ul>
          <p>Cadastre-as para prosseguir.<p/>`

          html = html.replace(/\,/g, '')

          objSwal.error.confirmButtonText = 'Cadastrar'
        } else {
          objSwal.error.confirmButtonText = 'Confirmar'
        }

        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = html

        return Swal.fire(objSwal.error)
      },
      async displayQuestion (title, text, itens) {
        let html = null

        if (itens && itens.length) {
          html = `<p>A sequência dos seguintes livros não foi configurada:</p>
          <ul>${itens.map(res => `<li><b>${res}</b></li>`)}</ul>
          <p>Deseja finalizar sem configurar?<p/>`

          html = html.replace(/\,/g, '')
        }

        objSwal.question.title = title
        objSwal.question.text = text
        objSwal.question.html = html
        objSwal.question.cancelButtonText = "Não"
        objSwal.question.confirmButtonText = "Sim"

        return await Swal.fire(objSwal.question).then(resp => {
          if (resp.value) {
            this.finish()
          }
        })
      },
      displaySuccess (title, text) {
        objSwal.success.title = title
        objSwal.success.text = text
        objSwal.success.html = null

        return Swal.fire(objSwal.success)
      },
      async finish () {
        const cartorio_id = this.$store.state.auth.cartorio_id
        try {

          loader({ text: 'Atualizando sequência de livros', active: true })

          await CartorioService.updatePrimeiroAcesso(cartorio_id)
          this.$store.dispatch('auth/setPrimeiroAcesso', true)

          this.displaySuccess('Etapa finalizada com sucesso.','').then(() => this.$router.push({name: 'rei_dashboard'}))
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({ text: '', active: false })
        }
      }
    }
  }
</script>
<style lang="scss">
  @import '../scss/_utilities/_exports';

  .thead {
    &--green {
      @extend %thead--variation;
      background-color: $color-light-green;
    }
  }

  .text {
    &--return {
      border-style: dashed !important;
      margin: pxToRem(12) auto;
      padding: pxToRem(12);
    }
  }

  .hr-wizard {
    margin-top: 50px;
    margin-bottom: 20px;
    background: #707070;
  }

</style>
